import React, { useState } from "react";

import { APIEndpoints } from "../constants/APIEndpoints";
import BaseClientNew from "../helper/BaseclientNew";

const usePromotions = () => {
  const [promotion, setPromotions] = useState(null);
  const [promotionLoading, setPromotionLoading] = useState(false);

  const getPromotions = async (token) => {
    try {
      const headers = {
        "x-user": token,
      };
      setPromotionLoading(true);
      await BaseClientNew.get(APIEndpoints.fetchPromotions, {
        headers,
        onSuccess: (res) => {
          console.log(res?.data, "response");
          setPromotions(res?.data);
        },
        onFailed: (err) => {
          console.log(err, "error");
        },
      });
    } finally {
      setPromotionLoading(false);
    }
  };
  const newPromotions = async (formData, { onSuccess, onFailed }) => {
    try {
      setPromotionLoading(true);
      await BaseClientNew.post(APIEndpoints.createPromotions, formData, {
        onSuccess: onSuccess,
        onFailed: onFailed,
      });
    } finally {
      setPromotionLoading(false);
    }
  };
  const deletePromotion = async (id, { onSuccess, onFailed, headers }) => {
    try {
      setPromotionLoading(true);
      await BaseClientNew.delete(APIEndpoints.deletePromotions + `/${id}`, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: headers,
      });
    } finally {
      setPromotionLoading(false);
    }
  };
  const updatePromotion = async (payload, { onSuccess, onFailed, headers }) => {
    try {
      setPromotionLoading(true);
      await BaseClientNew.post(APIEndpoints.updatePromotions, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: headers,
      });
    } finally {
      setPromotionLoading(false);
    }
  };

  const changePromotionStatus = async (
    id,
    { onSuccess, onFailed, headers }
  ) => {
    try {
      setPromotionLoading(true);

      await BaseClientNew.put(
        APIEndpoints.changePromotionStatus + `/${id}`,
        {},
        {
          onSuccess: onSuccess,
          onFailed: onFailed,
          headers: headers,
        }
      );
    } finally {
      setPromotionLoading(false);
    }
  };
  return {
    promotion,
    promotionLoading,
    getPromotions,
    newPromotions,
    deletePromotion,
    updatePromotion,
    changePromotionStatus
  };
};

export default usePromotions;
